// extracted by mini-css-extract-plugin
module.exports = {"playbar":"Playbar_playbar__2hgwz","icon-play":"Playbar_icon-play__10R8x","icon-pause":"Playbar_icon-pause__1fXjo"};